export default {
  app: {
    title: "Soul-Profiler",
    shorttitle: "SOPR",
    subtitle: "Entrepreneurship from your soul",
    subtitle2: "Discover your true purpose",
    buttons: {
      donate: "donate",
      soulprofile: "Soul-Profile®",
      relationprofile: "Love-Profile®",
      friendshipprofile: "Friendship Profile",
      familyprofile: "Family Profile",
      groupprofile: "Group Profile",
      lovelanguage: "Send love",
      purposegenerator: "Purpose Generator",
      calculate: "Calculate",
      surveypage: "Gotta love surveys",
      generate: "generate",
      dayenergy: "Energy of the day",
      PROBLEM_SOLVER: "Problem Solver®",
      TO_DAYENERGY: "meditate with day energy",
      today: "today",
      RESET: "Reset",
      NEW: "New",
      UPDATE: "Update",
      CANCEL: "Cancel",
      OK: "Ok",
      SAVE: "Save",
      CLEAR: "clear,",
      DELETE: "delete",
      REGISTER: "Sign Up",
      RESEND: "Resend",
      LOGIN: "Log in",
      SIGNOUT: "Sign out",
      LOADING: "Loading...",
      FORWARD: "Go",
      START: "Start",
      COPY_LINK: "Copy link",
      UPDATE_APP: "Update App",
      PURPOSE: "Your purpose",
      SOUL_PROFILE: "Your Soul Profile",
      LOVE_PROFILE: "Love-Profile",
      FRIEND_PROFILE: "Friend-Profile",
      ACCOUNT_YES_CLICK_HERE: "Already have an account? Click here",
      ACCOUNT_NO_CLICK_HERE: "Don't have an account yet? Click here",
      FORGOT_PASSWORD: "Forgot password?",
      RESEND_VERIFICATION: "Resend verification email",
      SEND_LOVE: "Send Love",
      SEND_LOVE_MESSAGE: "Send love yourself",
      SHARE: "share",
      CLOSE: "close",
      PRINT_TO_PDF: "Print to PDF",
      SAVE_TO_PDF: "Save to PDF",
      SAVE_IMAGE_JPG: "Save as JPG",
      SAVE_IMAGE_PNG: "Save as PNG",
      PRINT: "Print",
      CHANGE_DATA: "Change data",
      INPUT_USER_DATA: "Enter your data",
      DISCOVER_MORE: "discover more",
      BUY_SOULPROFILER_REPORT: "order Soul-Profiler report",
      GENERATE_REPORT: "Generate report",
      ORDER_BLUEPRINT: "Order Blueprint",
      ORDER_REPORT: "View report",
      DONATE_AMOUNT: "Donate €{amount}",
      ADD_NAME: "Add name",
      START_HERE: "Start here",
      YES: "Yes",
      NO: "No",
      LIVE_READING: "Book reading ({amount})",
      ONLINE_READING: "Online reading ({amount})",
      INTRO_READING: "Intro reading ({amount})",
      BOOK_READING: "Live reading ({amount})",
      BOOK_A_READING: "Book a reading",
      READ_MORE: "Read more",
      ORDER_BOOK: "Order book",
      SAVE_AS_IMAGE: "Save image",
      LOVE_TEST: "Love test",
      ADMIN_PAGE: "Admin page",
    },
    dialogs: {
      dialogdata: { title: "Enter your details" },
      dialogshare: {
        title: "Share Profile link",
        text: "Share your favorite Soul-Profile with friends",
      },
      liveReading: {
        title: "Book online reading",
        description:
          "Have your life question answered and gain immediate insight. Choose your session to move forward more clearly today!",
      },
      powercard: { title: "Scheppingskracht" },
      minireading: {
        titleToolbar: "Mini Reading",
        BOOK_LIVE_READING: "Live reading {price}",
        YOUR: "Your",
        ON_THE: "in the",
        disclaimer: {
          title: "disclaimer",
          text: "Book a live reading to delve deeper into your Soul-Profile and receive personal guidance.",
        },
      },
      generatereport: {
        title: "Generate report",
        text: "Order your unique Soul-Profiler report now for only {amount}",
        text2:
          "You will receive a unique digital report with your Soul-Profile within 7 days",
        button: "Order now",
        button_paperback: "Order paperback {amount}",
        button_digital: "Order digital PDF {amount}",
      },
      problemsolver: {
        TITLE: "Problem Solver®",
        ARE_YOU_FACING_A_PROBLEM: "Are you facing a challenge in your life?",
        CAN_YOU_FIX_IT: "Can you solve it yourself?",
        FIX_IT_NOW:
          "Fantastic!! You deserve a better reality. Now take the first step to fix it! And do it Today!",
        CALL_SUPPORT: "Call for help +31 6 28973952",
        BOOK_A_READING:
          "Ask for help or book a SoulProfiler reading and gain insight in your situation.",
        NO_PROCRASTINATION: "No procrastination, just do it now!",
      },
    },
    titles: { GENERATE_REPORT: "Order report", DAY_ENERGY: "Day Energy" },
    pages: {
      login: { toolbarTitle: "Log in" },
      account: { toolbarTitle: "Account Details" },
      updatepassword: { toolbarTitle: "Update Password" },
      index: { toolbarTitle: "Soul Profiler" },
      compass: { toolbarTitle: "SoulProfiler Compass" },
      booklanding: {
        toolbarTitle: "Soulprofiler – Book",
        title: "Soulprofiler – Book (incl. €50 bonus)",
      },
      parentsLanding: {
        toolbarTitle: "Soulprofiler for parents",
      },
      soulprofile: {
        toolbarTitle: "Soul Profile",
        title: "Your Soul Profile",
        dialog: { title: "Enter your details" },
      },
      relationprofile: {
        toolbarTitle: "Ideal partner",
        title: "Your Creation Powers",
        dialog: { title: "Enter your details" },
      },
      friendshipprofile: {
        toolbarTitle: "Friendship Power",
        title: "Your CreationPowers",
        dialog: { title: "Enter your details", user: "Soul" },
      },
      lovelanguage: {
        toolbarTitle: "Send Love",
        text: "",
      },
      purposegenerator: {
        toolbarTitle: "Purpose Generator",
        subtitle: "Your purpose on earth",
        sentence: {
          preamble: "Dear",
          pretext: "you may ",
          and: "and",
          karma: "Your most difficult theme",
          talent: "Your talent",
          soulvibration: "Soulvibration",
        },
      },
      dayenergy: {
        toolbarTitle: "Day Energy",
        dayTitle: "The energy of this day",
        day: "Day",
        monthTitle: "Theme of this month",
        teaserTitle: "Daily theme",
      },
      potato: { toolbarTitle: "Potato Darshan" },
      democard: { toolbarTitle: "Demo Card" },
      calculatenumbers: { toolbarTitle: "Calculate Numbers" },
      printwheel: { toolbarTitle: "Print wheel" },
      surveypage: { toolbarTitle: "Surveys" },
      customerpage: { toolbarTitle: "Customer" },
      adminsettings: { toolbarTitle: "Admin Settings" },
      bookinterest: { toolbarTitle: "Book Interest" },
      shop: { toolbarTitle: "Shop" },
      shoptest: { toolbarTitle: "Test Payment" },
      checkoutSuccess: { toolbarTitle: "Order Received" },
      checkoutCancelled: { toolbarTitle: "Payment Cancelled" },
      orderStatus: { toolbarTitle: "Order Status" },
      pdfreport: {
        toolbarTitle: "PDF Report",
        cover: {
          brand: "Soulprofiler",
          tagline: "Personal Soulprofiler Report",
          title: "Your five creation numbers",
          subtitle:
            "A first look at your medicine wheel and the movement of your energy.",
          nameLabel: "Name",
          birthdateLabel: "Date of birth",
          reportDateLabel: "Report date",
          note: "This report is a first layer of your wheel. Depth arises when you start playing with it in your daily life.",
        },
        intro: {
          kicker: "INTRODUCTION",
          title: "The Medicine Wheel",
          lead: "The medicine wheel is an ancient wisdom that follows the cycle of life, growth and transformation. It is a circle of energy that moves in four directions, with the heart as its central anchor point.\n\nYour five numbers together form your personal creation compass. They show how you think, act, feel, are present in matter, and what your heart truly desires. The four directions and the heart form a living circle: an infinite cycle that invites you each time to find your unique balance, so that you become a medicine for a more loving world.\n\nThe North represents thinking and inspirations. The East is doing, taking steps, and choosing direction. The South is feeling, emotion, and flow. The West is earth, body, and slowed energy. The heart connects all directions, whispers your inner truth, and opens when all themes of these elements are in balance.\n\nEach direction has a masculine and a feminine side. The masculine side pushes, steers, or accelerates. The feminine side feels, waits, softens, or withdraws. When you recognize both poles of duality, freedom of choice arises. You don't have to stay in one extreme; you can move and play with the energy.\n\nYour birth date activates these five forces in a unique pattern. With that, you have been given a unique task in time and space. That pattern is your creation wheel: a blueprint for how you choose, grow, and influence your reality. When you feel the wheel in your body, it becomes practical. You notice which side is active, which side you skip, and whether you end up pushing or withdrawing.\n\nBalance arises when you start playing with this movement. If something becomes too hard, soften. If something becomes too soft or hesitant, take a step. Thus, the wheel becomes a compass that always brings you back to your center.\n\nThe wheel is an invitation to trust your purity, your inspirations, and your intuition and feeling. These are unique and carry a medicinal power within them. The medicine against lovelessness and soullessness.\n\nThis report provides a first layer. The real deepening arises when you draw the wheel, feel in your body what happens, and work with it in your daily life.",
          numbersTitle: "Your five numbers",
          footer: "soulprofiler.com",
          cards: {
            heart: { label: "Soul", caption: "Heart / center" },
            air: { label: "Mission", caption: "North / air" },
            fire: { label: "Talent", caption: "East / fire" },
            water: { label: "Challenge", caption: "South / water" },
            earth: { label: "Path", caption: "West / earth" },
          },
        },
        pages: {
          heart: {
            kicker: "HEART / CENTER",
            title: "Soul number {number} - {theme}",
          },
          air: {
            kicker: "NORTH / AIR",
            title: "Life mission {number} - {theme}",
          },
          fire: {
            kicker: "EAST / FIRE",
            title: "Talent {number} - {theme}",
          },
          water: {
            kicker: "SOUTH / WATER",
            title: "Challenge {number} - {theme}",
          },
          earth: {
            kicker: "WEST / EARTH",
            title: "Life path {number} - {theme}",
          },
          dynamics: {
            kicker: "INTERACTION",
            title: "Dynamics between the numbers",
          },
          summary: {
            kicker: "SUMMARY",
            title: "Your reading",
            closingNote:
              "Notice which sentences stick with you the most. Those are often the places where your wheel invites you to look deeper.",
          },
        },
      },
    },
    components: {
      meditationTimer: {
        bar: { title: "Potato Meditation Timer" },
        text: {
          meditating: "Be like Potato",
          notMeditating: "Potato Time",
        },
        buttons: {
          start: "start",
          resume: "resume",
          reset: "reset",
          stop: "stop",
          pause: "pause",
        },
      },
    },
    labels: {
      birthdate: "Date of birth (dd-mm-yyyy)",
      firstname: "First name",
      email: "e-mail address",
      password: "password",
      password_repeat: "repeat password",
      energy: "energy",
      IN: "in",
      OUT: "out",
      MALE: "Male",
      FEMALE: "Female",
      FIND_BALANCE: "Balance between",
      powercard: "creationpower card",
      REGISTER: "Sign up",
      LOGIN: "Login",
      RESET_PASSWORD: "Reset password",
      DEAR: "Dear",
      MESSAGE: "Your message",
      MEANING_CREATION_NUMBER: "Meaning creation number",
      INNER_CORE_THEMES: "Your inner world themes",
      OUTER_WORLD_THEMES: "Your outer world themes",
      SHORTCUT_PURPOSE: "Shortcut to purpose",
      PURPOSE: "Purpose",
      TAKE_SURVEY: "Take the test",
      SURVEY_PAGE_TITLE: "test how high your heart is filled",
      WELCOME_SOUL_PROFILER: "Welcome Soul-Profiler",
      YOUR: "Your",
      YOUR_WHEEL: "Your Wheel",
      YOUR_SOUL_PROFILE: "Your Soul-Profile",
      INNER_CHILD: "inner child",
      EMOTION: "emotion",
      FEELING: "feeling",
      INNER_MALE: "inner man",
      INNER_FEMALE: "inner woman",
      INNER_WISE: "inner wise",
      SET_BOUNDARIES: "set boundaries",
      DO_THE_WORK: "do the work",
      DOING: "doing",
      THINKING: "thinking",
      THOUGHTS: "thoughts",
      IDEAS: "ideas",
      BEING: "being",
      NEW_REALITY: "new reality",
      FEELING: "feeling",
      HEALER: "healer",
      RESEND_VERIFICATION_MAIL: "Resend verification mail",
      ONE_COFFEE: "one cup of coffee",
      TWO_COFFEE: "two cups of coffee",
      THREE_COFFEE: "three cups of coffee",
      EXCL_IDEAL_TRANSACTION_COSTS: "excl. iDEAL transactioncosts",
      PREVIOUS_USERS: "Previous Wheels",
    },
    emails: {
      orderReport: {
        subject: "Order Soul-Profiler report",
        body: "Hi,\n\nI would like to order a soul-profiler report.\n\nMy name is {name}\nDate of birth is {date}.\n\nKind regards\n{name}",
      },
    },
    messages: {
      update: "Update available",
      underconstruction:
        "Oops, this section is still empty. This content is still a work in progress. Come back soon, because you don't want to miss this.",
      choice: "Make your choice",
      LIVE_READING_TEXT:
        "Do you have a question that’s been on your mind? In a short reading, you’ll receive clear and direct answers, aligned with your unique soul profile. Gain insight, clarity, and direction in just 30 minutes.",
      welcome: [
        "Follow your heart's desire today",
        "Just take a tiny step today",
        "Everything is vibration and information",
        "Today is now",
        "Be kind to yourself today",
        "Take a moment to consider your challenge",
        "Your soul's vibration whispers",
        "Are you following your heart's desire?",
        "What is your intention today?",
        "What is your challenge?",
        "Take a moment today to reflect on yourself",
        "What are you grateful for?",
        "Take time for yourself",
        "Play with today's energy",
        "You deserve a golden chair session",
        "Send a loving message to someone",
        "Asking for help is an act of love",
        "Balance is the key",
        "Living with passion is not always easy",
      ],
      WHAT_TO_DO_IN_THIS_APP: [
        "Discover your unique creative powers with your Soul-Profile",
        "Meditate with the daily energy for 10 minutes",
        "Check the themes of your relationship and experience more love in your life",
        "Send a loving message to someone",
        "Discover your life purpose with the purpose generator",
        "Learn about your karma or the most challenging themes in your life",
        "Measure your purpose score on the survey page. The surveys are still in beta and hidden somewhere on this page",
        "Receive darshan from Potato",
        "Give more attention and love to yourself",
        "Discover your unique talent with the Soul-Profiler",
        "Find balance in your life with your Soul-Profiler blueprint",
        "Live a more inspired life using the Soul-Profiler medicine wheel numerology",
        "Enjoy the mini-reading of your Soul-Profile",
        "Book a live Soul-Profile reading for only €25",
      ],
      LINK_COPIED: "Link copied to clipboard. Share it anywhere.",
      LOVE_COPIED: "Love message copied to clipboard. Share it anywhere.",
      SIGNUP_EMAIL_SENT: "You made it! Check your email for confirmation!",
      ACCOUNT_CREATED: "Done! Your account is ready to use.",
      NO_PAGE_ACCES: "Oops, register or login to acces this content",
      PASSWORD_RESET_SENT: "Password reset mail sent. Check your email.",
      DISCOVER: "discover your",
      GOOD_MORNING: "Goodmorning",
      GOOD_AFTERNOON: "Good afternoon",
      GOOD_EVENING: "Good evening",
      WHAT_ARE_YOU_GOING_FOR: "what are you going for",
      YOUR_INTENTION_TODAY: "what's your intention today?",
      YOUR_INTENTION: "what's your intention?",
      YOUR_CHALLENGE: "what's your challenge?",
      MESSAGE_RECEIVED: "You received a message",
      MESSAGE_DEFORMED: "The message could not be decoded",
      SECRET_FOUND: "You found a secret!",
      SURVEYS_ACTIVATED: "Survey page activated",
      VERIFICATION_MAIL_RESENT: "Resend verification mail. View your email",
      DONATE_COFFEE_MESSAGE:
        "I'm working with ❤️ on this app and I like to have coffee with friends. Support my work and thank me with",
      HELP_GROW_THIS_APP: "Help grow this app",
      ORDER_BOOK:
        "Order this unique and personal book now, discover your purpose on earth",
      SENDFOX_ERROR: "Could not subscribe to the newsletter",
    },
    warnings: {
      nameDate: "Enter valid name and date",
      valid_email: "Enter a valid email address",
      user_already_registered: "User already registered",
      LOGIN_REQUIRED:
        "Please login of create an account to access this feature",
      PLEASE_FILL_ALL_FIELDS: "Please fill in all fields",
    },
    winds: {
      heart: { text: "Heart", code: "H", explanation: "" },
      north: { text: "North", code: "N" },
      east: { text: "East", code: "E" },
      south: { text: "South", code: "S" },
      west: { text: "West", code: "W" },
    },
    elements: {},
  },

  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  dialogHelp: {
    title: "About the Soul-Profiler app",
    explanation: `The Soul-Profiler is based on the medicine wheel numberology. The medicine wheel originates from Native American Indian culture
    and is based on your <b>birthdate</b>.<br /><br />
    The calculated numbers in the wheel are about <b>balance</b> between masculine and feminine energy ♂♀.
    A play between outward movement and inward movement.<br /><br />
    The medicine wheel is used to provide <b>insight</b> into challenges in life.
    It encompasses a blueprint of your unique creative powers and qualities..`,
    buttonText: "Read more (nl)",
  },
  welcome: "Hi and welcome",
  numMeanings: [
    "desire of the heart",
    "connection",
    "communication",
    "creativity & balance",
    "building & playing",
    "clarity & understanding",
    "life energy",
    "make things balanced",
    "servitude",
    "leadership",
    "mastery",
    "complete",
  ],
  numMeanings1: [
    "Inner longing",
    "Connection & Relationship",
    "Interaction with a group",
    "Creativity & Balance",
    "Realizing & Recreation",
    "Wisdom & Intelligence",
    "Vitality",
    "Balancing",
    "Dedication",
    "Taking the lead",
    "Expertise & Craftsmanship",
    "Completion & Conclusion",
  ],
  minireading_bup: {
    air: [
      "You are a beatiful mirror in thoughts and ideas",
      "You may trust inspirations or ideas with desire of the heart",
      "You like to connect your thinking with others",
      "Share your ideas and thoughts within a group",
      "Your creative ideas start with chaos and structure",
      "Your thoughts and ideas are entrepreneurial",
      "Apparently, you have the clearest inspirations",
      "Let magical inspirations appear from the dark",
      "Breaking and healing thoughts are in your head",
      "Ensure your inspirations serve yourself",
      "You may take leadership over your inspirations & ideas",
      "Knowledge comes to you effortlessly",
      "You may ensure the completion of ideas",
    ],
    fire: [
      "You mirror peoples actions",
      "If you follow your heart's desires, you will achieve a lot",
      "When you collaborate, you get things done",
      "Share what lives within you when you are doing something in or with a group",
      "You have an artistic gift",
      "Playing and building is not strange to you",
      "You bring clarity and understanding in practical situations",
      "You often have more energy than others like a Duracell battery",
      "You have the action power to mend and heal",
      "Everything you do may serve yourself",
      "Take the lead in the execution of your creative process",
      "You enjoy teaching others or absorbing knowledge",
      "Come on, next project! Completion is your thing",
    ],
    water: [
      "You are a beatiful emotianal mirror",
      "Feel that you are always loved",
      "Connection with the other is what you desire most, but also the hardest",
      "Your knees tremble to share what's going on with you in a group, but that's okay",
      "You are a born artist and creator, now believe in yourself",
      "Being passive is sometimes important too",
      "Embrace the doubt about your intuition and knowledge",
      "Magical and depressive feelings are not strange to you",
      "You still find it exciting to break through things",
      "You are a born servant (to yourself)",
      "The feeling of doubt about leadership is part of it",
      "You were born as a teacher, you embody knowledge",
      "Rushing through or not starting at all? It's okay",
    ],
    earth: [
      "You are a beatiful mirror",
      "You like to just be with heart connection",
      "You like to be Together in connection with the other",
      "You prefer to be in a group where it feels safe",
      "Preferably, you live or hang out in a creative environment",
      "A 'playground' holds no secrets for you",
      "You like to be in a spiritual learning and living environment",
      "When you are present, magic can happen",
      "Your presence brings healing",
      "Being of service to yourself and others is your path",
      "People enjoy being with you with your leadership",
      "You enjoy being fully present in a classroom or learning environment",
      "You may fully enjoy a completed project or process",
    ],
    heart: [
      "You're heart is a beatiful mirror",
      "Your heart opens for someone with passion",
      "Your heart opens for someone who connects",
      "Your heart opens for someone who communicates what lives within him or her",
      "Your heart opens for someone who is creative or structured",
      "Your heart opens for someone who is playful and entrepreneurial",
      "Your heart opens for someone who brings clarity and understanding",
      "Your heart opens for someone with life energy",
      "Your heart opens for someone with healing qualities",
      "Your heart opens for someone who is of service",
      "Your heart opens for someone who takes leadership and responsibility",
      "Your heart opens for someone with a lot of knowledge or finetuning",
      "Your heart opens for someone who can complete things",
    ],
  },
  minireading: {
    air: [
      "reflective thoughts",
      "may trust inspirations or ideas with heartfelt desires",
      "likes to connect opposing thoughts",
      "enjoys sharing thoughts and ideas deeply ingrained in your life with a group",
      "receives creative ideas from chaos and structure",
      "plays with inspirations and thoughts and is enterprising in spirit",
      "receives a lot of information, clear thoughts, or inspirations",
      "conjures up magical inspirations and thoughts",
      "is often busy figuring out if it makes sense in the head",
      "gets helpful inspirations, also check if they serve yourself",
      "may take the lead on the inspirations & ideas",
      "can fine-tune and improve ideas like no other",
      "can ensure completion of ideas and thoughts, so action can be taken",
    ],
    fire: [
      "mirrors the actions of others",
      "brings unity to take steps in creation",
      "connects apparent contradictions to take action",
      "communicates what lives within with the group to take a step",
      "is the balancer or artist",
      "may build and play freely and is a real doer",
      "is the bringer of clarity in practical situations. You make creations clearer",
      "brings life energy. Work can be continued on the magic of creation",
      "prefers to make everything fit by either bonding or breaking",
      "ensures that the creation serves itself. Only then does a spirited creation arise",
      "may take the lead on the actions in a creation process",
      "is a master in fine-tuning the actions that may be taken",
      "brings completion of actions. Yes! Done! Onto the next step!",
    ],
    water: [
      "mirror, mirror",
      "often wonders if there is love for you",
      "prefers to connect with the other, but finds this simultaneously the most difficult",
      "is a bit shaky about sharing what's going on in you with a group and that's completely okay",
      "is a born artist or order creator, but doesn't feel that way.",
      "struggles with entrepreneurship, but is actually the best entrepreneur",
      "may embrace doubt about not knowing or understanding. You can really trust your intuition and knowledge",
      "struggles with life energy. You feel the energy like no other",
      "may find it exciting to break things or make them fit",
      "is a born servant. There's nothing wrong with that, but also really take care of yourself",
      "will likely always feel responsible everywhere and always",
      "may trust that there is enough knowledge available",
      "may take a moment to complete a creation. You feel the appropriate finishing communication",
    ],
    earth: [
      "reflective reality",
      "likes to be just with heartfelt connection",
      "would like to connect with the earthly body",
      "likes to be in a group where it feels safe",
      "deals with creativity and balance in matter",
      "likes to be in an enterprising environment. A 'playground' holds no secrets for you",
      "likes to be in a spiritual learning and living environment",
      "can create magic by just being present",
      "can provide healing in matter and body",
      "may be service-oriented and caring for yourself and others",
      "ensures that people enjoy being with you with your leadership",
      "fully enjoys being present in an earthly learning environment",
      "is happy with completed projects or processes. Will gladly have the last word",
    ],
    heart: [
      "opens up to someone who mirrors you",
      "is very subtle, seeks love, and opens up to someone with passion",
      "is very subtle, loves good relations, and opens up to someone who connects",
      "is very subtle, loves to communicate, and opens up to someone who shares what's in him or her",
      "is very subtle, loves balance, and opens up to someone who is creative or provides structure",
      "is very subtle, loves to play, and opens up to someone who is playful and enterprising",
      "is very subtle, loves clarity, and opens up to someone who brings clarity",
      "is very subtle, loves magic, and opens up to someone with energy",
      "is very subtle, loves when things feel right, and opens up to someone with healing or breakthrough qualities",
      "is very subtle, loves care, and opens up to someone who is service-oriented",
      "is very subtle, loves leadership, and opens up to someone who takes lead",
      "is very subtle, loves craftsmanship, and opens up to someone with a lot of knowledge and skill",
      "is very subtle, loves concluding, and opens up to someone who can complete",
    ],
  },
  creationNumbers1: {
    0: {
      title: "Ultimate mirror",
      negative: "negative mirroring",
      positive: "positive mirroring",
    },
    1: {
      title: "Desire of the heart",
      negative: "without passion",
      positive: "immersing in oneness",
    },
    2: {
      title: "Connection",
      negative: "completely out of connection",
      positive: "frenetic clinging connection",
    },
    3: {
      title: "Communication",
      negative: "not talking, withdrawing",
      positive: "much talking, no content",
    },
    4: {
      title: "Creativity & balance",
      negative: "rigid structure",
      positive: "total chaos",
    },
    5: {
      title: "Building & playing",
      negative: "passive, couch potato",
      positive: "active like a headless chicken",
    },
    6: {
      title: "Clarity & understanding",
      negative: "woolly medium",
      positive: "professor know-it-all",
    },
    7: {
      title: "Life energy",
      negative: "depression",
      positive: "magic ",
    },
    8: {
      title: "Healing",
      negative: "mending",
      positive: "breaking ",
    },
    9: {
      title: "Servitude",
      negative: "slimy pleaser",
      positive: "narcistic egoist",
    },
    10: {
      title: "Leadership",
      negative: "feeling powerless & weak",
      positive: "feeling overpowered,",
    },
    11: {
      title: "Mastery",
      negative: "apprentice",
      positive: "teacher",
    },
    12: {
      title: "Completion",
      negative: "not starting at all",
      positive: "rushing through things",
    },
  },
  creationNumbers2: {
    0: {
      title: "Ultimate mirror",
      negative: "negative mirroring",
      positive: "positive mirroring",
    },
    1: {
      title: "Inner longing & Heart's desire",
      negative: "without passion",
      positive: "immersing in oneness",
    },
    2: {
      title: "Connection & Relationship",
      negative: "out of connection",
      positive: "in connection",
    },
    3: {
      title: "Interaction with a group",
      negative: "not talking, withdrawing",
      positive: "much talking, no content",
    },
    4: {
      title: "Creativity & Balance",
      negative: "structure",
      positive: "chaos",
    },
    5: {
      title: "Realizing & Playfulness",
      negative: "passive",
      positive: "active",
    },
    6: {
      title: "Wisdom & Intelligence",
      negative: "medium",
      positive: "professor",
    },
    7: {
      title: "Vitality & Life Energy",
      negative: "depression",
      positive: "magic",
    },
    8: {
      title: "Balancing & Healing",
      negative: "mending",
      positive: "breaking",
    },
    9: {
      title: "Dedication & Servitude",
      negative: "pleaser",
      positive: "egoist",
    },
    10: {
      title: "Taking lead & Responsibility",
      negative: "feeling powerless",
      positive: "feeling empowered",
    },
    11: {
      title: "Expertise & Craftsmanship",
      negative: "apprentice",
      positive: "teacher",
    },
    12: {
      title: "Completion & Conclusion",
      negative: "not starting",
      positive: "rushing through",
    },
  },
  elements: {
    heart: {
      name: "heart",
      element: "heart",
      code: "H",
      icon: "favorite",
      direction: "heart",
      wind: "Heart",
      wheel: "Soulvibration",
      power: "Heart's desire",
      loveRelation: "Essence of your relationship",
      energy: "Unconditional love energy",
      color: "#a52422",
      backgroundcolor: "#fceeee",
    },
    air: {
      name: "thinking",
      element: "air",
      code: "N",
      icon: "air",
      direction: "north",
      wind: "North",
      wheel: "Life purpose",
      power: "Power of Thoughts",
      loveRelation: "Relationship goal",
      energy: "Fleeting energy",
      color: "#008f8f",
      backgroundcolor: "#ebffff",
    },
    fire: {
      name: "doing",
      element: "fire",
      code: "E",
      icon: "whatshot",
      direction: "east",
      wind: "East",
      wheel: "Talent",
      power: "Power of Doing",
      loveRelation: "Playing field",
      energy: "Action energy",
      color: "#ff7700",
      backgroundcolor: "#fff4eb",
    },
    water: {
      name: "Feeling",
      element: "Water",
      code: "S",
      icon: "water",
      direction: "South",
      wind: "South",
      wheel: "Karma",
      power: "Power of Feeling",
      loveRelation: "Most difficult theme",
      energy: "Flowing energy",
      color: "#3f88c5",
      backgroundcolor: "#eff5fa",
    },
    earth: {
      name: "being",
      element: "earth",
      code: "W",
      icon: "terrain",
      direction: "west",
      wind: "West",
      wheel: "Life path",
      power: "Power of presence",
      loveRelation: "Playing field ",
      energy: "Slow energy",
      color: "#1f1300",
      backgroundcolor: "#fff7eb",
    },
  },
  dayEnergyOptions: {
    0: [
      "I mirror people",
      "I am the ultimate mirror",
      "My emptiness is love",
      "I bring healing by mirroring",
    ],
    1: [
      "I am feeling my heart's desire",
      "i am connected to my heart",
      "I radiate love",
    ],
    2: [
      "I connect with the other side",
      "Today I connect contradictions",
      "Time to connect",
    ],
    3: [
      "I communicate of what lives within me with ease",
      "Today, I communicate my inner feelings towards a group",
      "I communicate my deepest heart's desire",
    ],
    4: [
      "I am the source of creation",
      "I am creative",
      "Today I bring balance to things",
      "I will show my creative skills",
    ],
    5: [
      "I have fun in building and playing!",
      "Today is laying a sturdy foundation day",
      "I am a great entrepeneur!",
      "Today I am just going to work on my creation",
    ],
    6: [
      "Today I will receive clarity about things",
      "I trust my intuition",
      "By analyzing the situation, it becomes clearer ",
      "My mind is a clear mind",
    ],
    7: [
      "I am letting go of my pent-up sorrow",
      "I bounce around happily",
      "I really have enough energy today",
    ],
    8: [
      "Today is my breakthrough day",
      "I use my healing powers today",
      "I am finally going to mend that thing today!",
      "I am finally going to break that thing today.",
    ],
    9: [
      "Today, I will be of service to myself",
      "I am taking good care of myself today",
      "By taking care of myself, I take care of others",
      "I Find balance in being selfish or being a people-pleaser",
    ],
    10: [
      "I am taking my responsibility today",
      "Today I take the lead ",
      "I step into my powerful energy",
    ],
    11: [
      "Time to fine-tune my creation",
      "I really have enough information",
      "I embody my mastery today",
      "It does not always have to be perfect",
    ],
    12: [
      "Time to finish things up",
      "I don't have to rush things today",
      "I am taking a step to finish this thing",
    ],
  },
  textHeart: {
    0: ["Ultimate mirror", "pure mirror", "Emptiness", "The all"],
    1: ["heart's desire", "heart connection", "unity", "love"],
    2: ["connection", "connectedness", "bridging contradictions"],
    3: ["communication from your heart", "Speaking in front of a group"],
    4: ["creativity", "balance", "chaos", "structure"],
    5: ["playing", "building", "undertaking", "composing", ""],
    6: ["clarity", "a clear sky", "clarity and understanding", "a clear mind"],
    7: ["magic", "sorrow", "life energy"],
    8: ["a healing heart", "healing", "breakthrough energy"],
    9: ["concerns", "service-oriented", "about"],
    10: ["responsibility", "leadership", "powerful leadership"],
    11: ["Teacher", "student", "master"],
    12: ["completion", "closing heart energy", "conclusive communication"],
  },
  textNorth: {
    0: [
      "Thé mirror",
      "ultimate mirror",
      "The all and nothing",
      "The emptiness",
    ],
    1: ["heart's desire", "heart connection", "unity"],
    2: ["making connections", "bridging contradictions", "connecting people"],
    3: [
      "communicating what lies deep within you",
      "talking about your soul mission",
      "addressing groups",
    ],
    4: [
      "creating",
      "bringing balance",
      "bringing structure",
      "showing your arts",
    ],
    5: [
      "bring playful ideas",
      "build a strong foundation in the minds",
      "undertake wholehearted",
      "just build and play",
      "just be playful",
    ],
    6: ["brighter ideas", "understanding", "clarity"],
    7: ["using magical ideas", "bringing life energy"],
    8: ["heal mankind", "break and mend thoughts", "use healing ideas"],
    9: ["being of service", "using service-oriented ideas", "being of service"],
    10: ["take responsibility", "show leadership", "take the lead"],
    11: ["bring masterful ideas", "bring mastery"],
    12: [
      "finish things in your mind",
      "complete community projects",
      "cummunicate finishing thoughts& idea",
    ],
  },
  textEast: {
    0: [
      "and mirroring people ",
      "and bring people to their core",
      "and embrace the emptiness",
    ],
    1: ["heart's desire", "heart connection", "unity"],
    2: ["making connections", "bridging contradictions", "connecting people"],
    3: [
      "communicating what lies deep within you",
      "talking about your soul mission",
      "addressing groups",
    ],
    4: [
      "creating",
      "bringing balance",
      "bringing structure",
      "showing your arts",
    ],
    5: [
      "bringing playfulness",
      "building foundation",
      "undertaking",
      "building",
    ],
    6: ["creating clarity", "clarifying information", "creating clarity"],
    7: ["bringing out magic", "bringing energy", "generating life energy"],
    8: [
      "taking healing steps",
      "breaking habits",
      "bringing inside and outside together",
    ],
    9: ["concerns", "service-oriented", "about"],
    10: ["take responsibility", "show leadership", "take the lead"],
    11: [
      "utilizing mastery",
      "sharing your knowledge",
      "fine-tuning knowledge",
    ],
    12: ["finishing", "rushing through", "not starting"],
  },
  textWest: {
    1: ["heart's desire", "heart connection", "unity"],
    2: ["to make connections", "to bridge contradictions", "to connect people"],
    3: [
      "and simply be yourself in a group",
      "with groups of people",
      "to address groups",
    ],
    4: [
      "creating",
      "bringing balance",
      "bringing structure",
      "showing your arts",
    ],
    5: [
      "bringing playfulness",
      "building foundation",
      "undertaking",
      "building",
    ],
    6: ["creating clarity", "clarifying information", "creating clarity"],
    7: ["for a magical reality", "for more life energy in matter"],
    8: [
      "for a coherent reality",
      "for a reality without bullshit",
      "for spiritual growth",
      "for healing in the body",
    ],
    9: ["concerns", "service-oriented", "about"],
    10: [
      "taking responsibility in matter",
      "showing leadership by being there",
      "taking responsibility over your body",
    ],
    11: ["Teacher", "student", "master"],
    12: ["finishing", "completing", "clarifying"],
  },
  textSouth: {
    1: ["heart's desire", "heart connection", "unity"],
    2: ["connection", "relationships"],
    3: [
      "communicating what lies deep within you",
      "communicating with a group",
      "addressing groups",
    ],
    4: ["creativity & balance"],
    5: ["bringing playfulness & building", "undertaking"],
    6: ["bringing clarity & understanding", "information"],
    7: ["life energy", "depression & magic"],
    8: ["making coherent", "healing"],
    9: ["service", "concerns"],
    10: ["responsibility", "leadership"],
    11: ["Mastery", "Knowledge"],
    12: ["finishing", "ending", "completing", "closing", "fulfilling"],
  },
};
